import { gql } from "@apollo/client";

const SAVE_INSUMO_CAPACITACION_AE = gql`
    mutation saveVisitaInsumoCapacitacionAE($input: AddVisitaInsumoCapacitacionInput!, $idTeleEnfermeria: Int!){
        saveVisitaInsumoCapacitacionAE(input: $input, idTeleEnfermeria: $idTeleEnfermeria) {
            idInsumoCapacitacion
        }
    }
`;

export default SAVE_INSUMO_CAPACITACION_AE;

export const adaptAddVisitaInsumoCapacitacionInput = (data) => ({
  idTeleEnfermeria: data?.idTeleEnfermeriaAE,
  input: {
    idInsumoCapacitacion: data?.idInsumoCapacitacion || 0,
    insumoVencido: data?.insumoVencido,
    cantidadSuficiente: data?.cantidadSuficiente,
    reclamoCantidadCalidad: data?.reclamoCantidadCalidad,
    observacionCapacitacion: data?.observacionCapacitacion
  }
});